import { TouchableWithoutFeedback } from 'react-native'
import { TextLinkStyle } from './TextLinkStyle.js'

export const TextLink = ({ onPress, underline = true, children }) => (
  // Use TouchableWithoutFeedback rather than Pressable since the
  // former does not add a View to the component hierarchy
  <TouchableWithoutFeedback onPress={onPress}>
    <TextLinkStyle underline={underline}>{children}</TextLinkStyle>
  </TouchableWithoutFeedback>
)
